import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { SectionCategoryNames } from '@app/domain/sections';
import LinkSelectableBulletedItem from '@app/components/LinkSelectableBulletedItem';

interface Props {
  category: SectionCategory | undefined;
  sections: Section[];
  selectedSectionId: string | undefined;
  className?: string;
}

const SectionCategory: FC<Props> = ({ category, sections, selectedSectionId, className }) => {
  return (
    <div className={className}>
      <SectionTitle>{category && SectionCategoryNames[category]}</SectionTitle>
      <NavItems>
        {sections.map(
          (section): ReactNode => (
            <LinkSelectableBulletedItem
              id={`btn-sidebar-item-${category}-${section.id}`}
              dataTestId={`btn-openselect-item-${section.id}`}
              key={section.id}
              selected={section.id === selectedSectionId}
              to={section.baseRoute.path}
            >
              {section.name}
            </LinkSelectableBulletedItem>
          ),
        )}
      </NavItems>
    </div>
  );
};

export default SectionCategory;

const SectionTitle = styled.h3`
  font-family: 'SF Pro', 'Inter', system-ui, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #ffffff52;
  padding-left: 0.75rem;
  margin: 0 0 0.5rem 0;
`;

const NavItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
